<template>
  <section class="gallery-design-study" aria-label="Explore The View Gallery">
    <header class="gallery-design-heading">
      <p>The View Gallery brings the shared exhibitions into one place. Visitors can browse questions other people have asked, preview a reading and choose an exhibition to enter. They can also compose a View of their own or explore the original projects and writing.</p>
      <p>{{ galleryDesignIntroduction }}</p>
      <ProjectExperienceAction class="gallery-design-entry" to="/views?presentation=museum&temporaryPresentation=1">Enter the Gallery</ProjectExperienceAction>
    </header>
    <div class="gallery-design-plates">
      <GalleryDesignPlate v-for="(feature,index) in features" :key="feature.id" :feature="feature" :number="index + 1" :dark="dark" />
    </div>
  </section>
</template>
<script>
import GalleryDesignPlate from './GalleryDesignPlate.vue';
import ProjectExperienceAction from './ProjectExperienceAction.vue';
import { galleryDesignIntroduction, galleryStudyFeatures } from '../../data/galleryDesignStudies';
import { initialExhibitionDarkMode } from '../../utils/exhibitionTheme';
export default {
  components: { GalleryDesignPlate, ProjectExperienceAction },
  data: () => ({ dark: initialExhibitionDarkMode() }),
  computed: {
    galleryDesignIntroduction() { return galleryDesignIntroduction; },
    features() { return ['hall-across', 'building', 'orientation', 'light-dark'].map(id => galleryStudyFeatures.find(feature => feature.id === id)); },
  },
  mounted() { window.addEventListener('theme-change', this.syncTheme); },
  beforeUnmount() { window.removeEventListener('theme-change', this.syncTheme); },
  methods: { syncTheme() { this.dark = initialExhibitionDarkMode(); } },
};
</script>
<style scoped>
.gallery-design-study { margin-top:0; }
.gallery-design-heading { max-width:52rem; }
.gallery-design-heading h4 { margin:0 0 1rem;font:400 clamp(1.28rem,1.75vw,1.55rem)/1.3 'PT Serif',Georgia,serif;color:var(--case-ink); }
.gallery-design-heading p { margin:0;font:1.05rem/1.8 'PT Serif',Georgia,serif;color:var(--case-muted); }
.gallery-design-heading p+p { margin-top:1rem; }
.gallery-design-entry{margin-top:.8rem;}
.gallery-design-plates { display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:30px 34px;margin-top:2rem;align-items:start; }

@media(max-width:640px) { .gallery-design-heading p { font-size:1rem;line-height:1.75; }.gallery-design-plates { gap:18px 14px;margin-top:1.5rem; } }
</style>
